import { render, staticRenderFns } from "./block.vue?vue&type=template&id=33d163fe&scoped=true&"
import script from "./block.vue?vue&type=script&lang=js&"
export * from "./block.vue?vue&type=script&lang=js&"
import style0 from "./block.vue?vue&type=style&index=0&id=33d163fe&prod&lang=less&scoped=true&"
import style1 from "./block.vue?vue&type=style&index=1&id=33d163fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d163fe",
  null
  
)

export default component.exports